import * as R from 'ramda';
import { isNullOrUndefined } from 'util';

export const equals = R.curry((a: any, b: any) => a === b);

export const isEmpty = (object: any) => isNullOrUndefined(object) || Object.keys(object).length === 0;

export const parse = (value: string) => (isNullOrUndefined(value)) ? null : JSON.parse(value);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/utils/object.utils.ts